import { orderBy } from "lodash";

import {
  GoalBasedInsuranceType,
  GoalBasedInsuranceTypeLabel,
  GoalBasedInsuranceTypeMap,
  GoalBasedLifeInsuranceTypeMap,
} from "@fartherfinance/frontend/api/FinancialPlans/insurance/types";

import getEntries from "@src/utils/entries";

export interface InsuranceOption {
  id: GoalBasedInsuranceType;
  label: GoalBasedInsuranceTypeLabel;
}

const insuranceOptionEntries = getEntries(GoalBasedInsuranceTypeMap);

export const insuranceOptions = orderBy(
  insuranceOptionEntries.map(([key, value]) => ({
    label: value,
    id: key,
  })),
  [(g) => g.label],
  ["asc"]
);

const lifeInsuranceOptionsEntries = getEntries(GoalBasedLifeInsuranceTypeMap);

export const lifeInsuranceOptions = lifeInsuranceOptionsEntries.map(
  ([key, value]) => ({
    label: value,
    value: key,
  })
);

export const LifeTypeField = "LifeTypeField";
export const InsuranceCarrierField = "InsuranceCarrierField";
export const PolicyNumberField = "PolicyNumberField";
